import {
  BellIcon,
  CheckIcon,
  CircleDot,
  CircleDotIcon,
  CircleXIcon,
  DotIcon,
  LucideKeyRound,
  TrendingUpIcon,
  TrophyIcon,
  TruckIcon,
  XIcon,
} from "lucide-react";

import {
  NotificationDTONotificationType,
  type NotificationDTONotificationType as NotificationType,
} from "@/common/api/sdk";

export const getNotificationIcon = (type?: NotificationType) => {
  const props = {
    size: 24,
  };

  switch (type) {
    case NotificationDTONotificationType.APPROVED:
      return <CheckIcon {...props} className="text-green-600" />;
    case NotificationDTONotificationType.NOTIFICATION:
      return <CircleDotIcon {...props} className="text-blue-600" />;
    case NotificationDTONotificationType.TRADE:
      return <TrendingUpIcon {...props} className="text-green-600" />;
    case NotificationDTONotificationType.WINNER:
      return <TrophyIcon {...props} className="text-yellow-600" />;
    case NotificationDTONotificationType.REJECTION:
      return <CircleXIcon {...props} className="text-red-600" />;
    default:
      return <BellIcon {...props} className="text-gray-600" />;
  }
};
